import { AppSettingsModule } from 'services/settings.provider';
import { DataServiceModule } from 'services/data/data.service';

export const AvalaraServiceModule = angular
    .module('app.services.data.avalaraService', [
        AppSettingsModule,
        DataServiceModule
    ]).service('avalaraService', (
        dataService,
        settings
    ) => {
        return {
            getAvalaraStatus,
            getCredentials,
            getTaxProvider,
            isAvalaraEnabled
        };

        function getCredentials() {
            return dataService.get(settings.api.avalaraCredential);
        }

        function getTaxProvider() {
            return dataService.get(settings.api.taxProvider);
        }

        function isAvalaraEnabled() {
            return getTaxProvider()
                .then(taxProvider => taxProvider.taxProvider === 'AVALARA')
                .catch(() => false);
        }

        function getAvalaraStatus() {
            return dataService.get(settings.api.avalaraStatus);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/avalara.service.js